import * as React from 'react';

import { cn } from '@/lib/utils';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogOverlay,
    DialogPortal,
    DialogTitle,
    DialogTrigger,
} from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';

/**
 * Extensões do dialog shadcn — arquivo separado para sobreviver a `shadcn add --reinstall`.
 *
 * Uso:
 * <DialogScrollContent>
 *   <DialogScrollHeader>...</DialogScrollHeader>
 *   <DialogBody>...</DialogBody>
 *   <DialogScrollFooter>...</DialogScrollFooter>
 * </DialogScrollContent>
 */

function ScrollDialogContent({ className, children, ...props }) {
    return (
        <DialogContent
            className={cn(
                'grid max-h-[min(90vh,calc(100dvh-2rem))] grid-rows-[auto_minmax(0,1fr)_auto] gap-0 overflow-hidden p-0 sm:max-w-lg',
                className,
            )}
            {...props}
        >
            {children}
        </DialogContent>
    );
}

function ScrollDialogHeader({ className, ...props }) {
    return (
        <DialogHeader
            data-slot="dialog-scroll-header"
            className={cn('shrink-0 gap-1.5 border-b px-4 py-4 pr-12', className)}
            {...props}
        />
    );
}

function DialogBody({ className, children, ...props }) {
    return (
        <div data-slot="dialog-body" className="min-h-0 overflow-hidden">
            <ScrollArea className={cn('h-full max-h-full', className)} {...props}>
                <div className="px-4 py-4">{children}</div>
            </ScrollArea>
        </div>
    );
}

function ScrollDialogFooter({ className, ...props }) {
    return (
        <DialogFooter
            data-slot="dialog-scroll-footer"
            className={cn(
                '!mx-0 !mb-0 m-0 shrink-0 rounded-none border-t bg-muted/50 px-4 py-4',
                className,
            )}
            {...props}
        />
    );
}

export {
    Dialog,
    DialogBody,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogOverlay,
    DialogPortal,
    DialogTitle,
    DialogTrigger,
    ScrollDialogContent,
    ScrollDialogFooter,
    ScrollDialogHeader,
};
